import { createApi } from '@reduxjs/toolkit/query/react';
import { CoursesWithModules, DeleteCourses, AddCourses } from '../../api/endpoints';
import {baseQueryWithReauth} from "../../api/baseQuery";

export const getAllCoursesApi = createApi({
  reducerPath: 'getAllCoursesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Courses'],  
  endpoints: (builder) => ({
    getAllCourses: builder.query({
      query: () => ({ url: CoursesWithModules,  method: 'GET'}),
      providesTags: [{ type: 'Courses', id: 'GET' }],
    }),
    deleteCourse: builder.mutation({
      query: (courseId) => ({ 
        url: DeleteCourses, 
        method: 'POST',
        body: { courseId },
      }),
      // This will cause the 'getAllCourses' query data to be refetched
      // whenever this mutation succeeds
      invalidatesTags: [{ type: 'Courses', id: 'GET' }],
    }),
    addCourse: builder.mutation({
      query: (newCourseData) => ({
        url: AddCourses,
        method: 'POST',
        body: newCourseData,
      }),
      invalidatesTags: [{ type: 'Courses', id: 'GET' }],
    }),
  }),
})

export const { useGetAllCoursesQuery, useDeleteCourseMutation, useAddCourseMutation } = getAllCoursesApi;
